// Langue d'affichage du widget, choisie par le site hôte (option `lang`,
// attribut `data-lang` ou paramètre d'URL `?lang=`). Toute valeur inconnue
// retombe sur le français, langue historique du widget.
import { messages as en } from "./messages.en.js";
import { messages as es } from "./messages.es.js";
import { messages as fr } from "./messages.fr.js";

const CATALOGS = { fr, en, es };

export const DEFAULT_LANG = "fr";
export const SUPPORTED_LANGS = Object.keys(CATALOGS);

/** « en-US », « ES », « es_MX » → « en », « es » ; inconnu ou vide → « fr ». */
export function resolveLang(value) {
  const base = String(value || "").trim().toLowerCase().split(/[-_]/)[0];
  return CATALOGS[base] ? base : DEFAULT_LANG;
}

export function getMessages(lang) {
  return CATALOGS[resolveLang(lang)];
}

/** Remplace les « {nom} » d'un texte : format("{count} créneaux", { count: 3 }). */
export function format(template, values = {}) {
  return String(template).replace(/\{(\w+)\}/g, (match, key) => (key in values ? String(values[key]) : match));
}
